module.exports = __webpack_public_path__ + "img/app-2.b0da84bd.png";